<script lang="ts">
  import TextNew from "./TextNew.svelte";

  export let dateRange: string;
  export let filteringDate: string | undefined = undefined;
  export let element: HTMLElement | null = null;
</script>

<button on:click bind:this={element}>
  <TextNew font="ocr" as="span" size="xs" weight="medium">{dateRange}</TextNew>
  {#if filteringDate}
    <TextNew as="span" size="xxs" --rk-text-color="var(--rk-text-transparency-dark)">
      {filteringDate}
    </TextNew>
  {/if}
</button>

<style>
  button {
    display: flex;
    background-color: var(--rekki-neutral-01);
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    padding: 0px 16px;
    min-height: 40px;
    min-width: 136px;
    flex-direction: column;
    font-size: var(--rk-font-size-xs);
  }
</style>
